import { render, staticRenderFns } from "./Restore.vue?vue&type=template&id=b1a976b4&scoped=true&lang=pug"
import script from "./Restore.vue?vue&type=script&lang=ts"
export * from "./Restore.vue?vue&type=script&lang=ts"
import style0 from "./Restore.vue?vue&type=style&index=0&id=b1a976b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a976b4",
  null
  
)

export default component.exports